import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TicketsState, Ticket } from './ticketsTypes';
import { ticketsAPI } from './ticketsAPI';

const initialState: TicketsState = {
  tickets: [],
  currentTicket: null,
  loading: false,
  error: null,
};

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    setCurrentTicket: (state, action: PayloadAction<Ticket | null>) => {
      state.currentTicket = action.payload;
    },
    clearTicketsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Tickets
    builder.addMatcher(
      ticketsAPI.endpoints.getTickets.matchFulfilled,
      (state, action) => {
        state.tickets = action.payload.tickets;
      }
    );
    
    // Get Event Tickets
    builder.addMatcher(
      ticketsAPI.endpoints.getEventTickets.matchFulfilled,
      (state, action) => {
        state.tickets = action.payload;
      }
    );
    
    // Create Ticket
    builder.addMatcher(
      ticketsAPI.endpoints.createTicket.matchFulfilled,
      (state, action) => {
        state.tickets.unshift(action.payload);
        state.currentTicket = action.payload;
      }
    );
  },
});

export const { setCurrentTicket, clearTicketsError } = ticketsSlice.actions;
export default ticketsSlice.reducer;
